






























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {CommentState} from '@/types/Comment';
import {deleteComment} from '@/clients/UserCommentsClient';
import {format} from 'fecha';
import {ControlParams, CustomParams, EventParams} from 'vue-gtag2';
import {VueGtag} from 'vue-gtag';
import DisplayMarkup from '@/components/DisplayMarkup.vue';
import {DateFormats} from '@/types/DateFormats';

@Component({
  name: 'AdComment',
  components: {DisplayMarkup},
})
export default class AdComment extends Vue {
  @Prop({type: String, default: 'div'}) readonly component!: string;
  @Prop({type: String, required: true}) readonly id!: string;
  @Prop({type: String, required: true}) readonly advertisementId!: string
  @Prop({type: String, required: true}) readonly author!: string;
  @Prop({type: String, required: true}) readonly body!: string;
  @Prop({type: String, required: true}) readonly created!: string;
  @Prop({type: String, required: true}) readonly state!: CommentState;

  private get stateClass(): string {
    switch (this.state) {
      case CommentState.NEW:
        return 'bg-light';
      case CommentState.PUBLISHED:
        return '';
      case CommentState.DELETED:
      case CommentState.REJECTED:
        return 'bg-light text-muted';
      default:
        return 'border border-danger rounded';
    }
  }

  private get commentState(): string {
    switch (this.state) {
      case CommentState.DELETED:
        return 'usunięty';
      case CommentState.NEW:
        return 'oczekuje na akceptację';
      case CommentState.PUBLISHED:
        return 'opublikowany';
      case CommentState.REJECTED:
        return 'odrzucony';
      default:
        return 'status nieznany';
    }
  }

  private get deletePossible(): boolean {
    return this.state === CommentState.NEW
      || this.state === CommentState.PUBLISHED;
  }

  private onDeleteClick(body: string): void {
    this.$bvModal.msgBoxConfirm(`Czy na pewno chcesz usunąć komentarz?\n\n${body}`, {
      title: 'Potwierdź',
      okTitle: 'Tak',
      cancelTitle: 'Nie',
    }).then(yes => {
      if (yes) {
        this.doDelete();
      }
    });
  }

  private doDelete(): void {
    let success = false;
    deleteComment(this.advertisementId, this.id).then(result => {
      if (result.ok) {
        success = true;
        this.$bvModal.msgBoxOk('Komentarz został usunięty');
      } else {
        this.$bvModal.msgBoxOk(`Coś poszło nie tak: ${result.statusText}`);
      }
    }).catch(err => {
      this.$bvModal.msgBoxOk(`Coś poszło nie tak: ${err}`);
    }).finally(() => {
      this.$emit('deleted');
      this.trackDeleteEvent({success});
    });
  }

  private trackDeleteEvent(eventParams: ControlParams | EventParams | CustomParams): void {
    if (process.env.NODE_ENV === 'production') {
      (this.$gtag as VueGtag).event('deleteComment', eventParams);
    }
  }

  private formatDate(dateStr: string): string {
    return format(new Date(dateStr), DateFormats.DATE_TIME);
  }

  private getTexts(body: string): Array<string> {
    return body.split('\n');
  }
}
